import { InformationCard } from '../../../components';
import AddressCard from '../../../components/AddressCard';
import SalesChannelCard from '../../../components/SalesChannelCard';

function LocationDetailsSkeleton(): JSX.Element {
  return (
    <>
      <InformationCard.Skeleton />
      <AddressCard.Skeleton />
      <SalesChannelCard.Skeleton />
    </>
  );
}

export default LocationDetailsSkeleton;
